import { DICTIONARY } from "@/utils/constants/constants.dictionary";
import { TYPE_BIDDING_INFO_JSON } from "@/assets/typeTenderJSON";
/**
 * 搜索时间类型
 * 1=近一年，
 * 2近一周，
 * 3=近一月，(默认)
 * 7今天
 * 8近三个月
 * 9近半年
 * 4  5  6 自定义时间区间, 此时startTime和endTime不能为空
 *    4自定义格式为 年月日  例如2016-12-19
 *    5自定义格式为 年月日时  例如2016-12-19 08
 *    6自定义格式为 年月日时分秒   例如2016-12-19 08:00:0099自定义格式为 年月日时分秒   例如2016-12-19 00:00:00, 这一个智能订阅器和普通订阅器都合用
 * **/
export const SUBSCRIBE_TIME_LIST = [
  { id: 1, text: "当天" },
  { id: 2, text: "昨天" },
  { id: 3, text: "近一周" },
  { id: 4, text: "近一个月" },
  { id: 5, text: "近三个月" },
  { id: 6, text: "近六个月" },
  { id: 7, text: "近一年" },
  { id: 8, text: "自定义" },
];
export const BIDDING_INFO_COMPANY_TYPE = [
  {
    id: -1,
    text: "全部",
  },
  {
    id: 1,
    text: "采购商",
  },
  {
    id: 2,
    text: "供应商",
  },
];
export const PROJECTSORT_TYPE = [
  {
    label: 2,
    name: "综合排序",
  },
  {
    label: 1,
    name: "按时间排序",
  },
  {
    label: 3,
    name: "相关性排序",
  },
];
export const SORT_TYPE = [
  {
    label: 4,
    name: "智能排序",
  },
  {
    label: 1,
    name: "按时间排序",
  },
  {
    label: 3,
    name: "相关性排序",
  },
];
export const PURCHASE_INTENTION_SORT_TYPE = [
  {
    label: 4,
    name: "智能排序",
  },
  {
    label: 1,
    name: "按时间排序",
  },
  {
    label: 6,
    name: "相关性排序",
  },
];
/** 设置模式  */
export const SUBSCRIPTION_SETTING_MODE = [
  { label: "快速设置", value: 1 },
  { label: "专业设置", value: 2 },
];

/** 查询范围  */
export const SUBSCRIPTION_QUERY_RANGE = [
  { label: "全文", value: 1 },
  { label: "标题", value: 2 },
  { label: "产品/标的", value: 9 },
];

/** 信息类型  */
export const SUBSCRIPTION_INFORMATION_TYPE = [
  { label: "不限", value: "" },
  ...TYPE_BIDDING_INFO_JSON.map((item) => {
    return {
      label: item.text,
      value: item.id - 0,
    };
  }),
];

/** 采购单位 */
export const SUBSCRIPTION_PURCHASING_UNIT = [
  { label: "不限", value: "" },
  ...DICTIONARY.PURCHASING_UNIT.map((item) => {
    return {
      label: item.text,
      value: item.id,
    };
  }),
  { label: "自定义", value: "99" },
];

/** 采购类型 */
export const SUBSCRIPTION_PURCHASE_TYPE = [
  { label: "不限", value: "" },
  { label: "货物", value: 1 },
  { label: "工程", value: 2 },
  { label: "服务", value: 3 },
];

/** 金额范围 */
export const SUBSCRIPTION_AMOUNT_RANGE = [
  { label: "排除指定金额项目", value: 0 },
  { label: "只看指定金额项目", value: 1 },
];

/** 搜索模式 */
export const SUBSCRIPTION_SEARCH_MODE = [
  { label: "精准", value: 2 },
  { label: "模糊", value: 1 },
];

/** 项目金额 */
export const SUBSCRIPTION_AMOUNT = [
  {
    id: -1,
    beginAmount: "",
    endAmount: "",
    text: "全部",
  },
  {
    id: 2,
    beginAmount: "",
    endAmount: "100000",
    text: "10万以下",
  },
  {
    id: 3,
    beginAmount: "100000",
    endAmount: "500000",
    text: "10-50万",
  },
  {
    id: 4,
    beginAmount: "500000",
    endAmount: "1000000",
    text: "50-100万",
  },
  {
    id: 5,
    beginAmount: "1000000",
    endAmount: "2000000",
    text: "100-200万",
  },
  {
    id: 6,
    beginAmount: "2000000",
    endAmount: "5000000",
    text: "200-500万",
  },
  {
    id: 7,
    beginAmount: "5000000",
    endAmount: "",
    text: "500万以上",
  },
  {
    id: 99,
    beginAmount: "",
    endAmount: "",
    text: "",
    hide: true,
  },
];

// 截止时间,建议不要和registrationStatus报名时间一起使用,
// 0.报名或投标未截止：报名截止时间>=当天日期 或 投标截止时间>=当天日期
// 1.报名未截止：报名截止时间>=当天日期
// 2.投标未截止：投标截止时间>=当天日期
// -2.无报名和投标时间：报名截止时间为空   且  投标截止时间为空
/** 截止时间 */
export const SUBSCRIPTION_DEADLINE = [
  {
    id: -1,
    text: "全部",
  },
  {
    id: 0,
    text: "报名或投标未截止",
  },
  {
    id: 1,
    text: "报名未截止",
  },
  {
    id: 2,
    text: "投标未截止",
  },
  {
    id: -2,
    text: "无报名和投标时间",
  },
];

/** 采购意向查询范围  */
export const SUBSCRIPTION_PURCHASE_QUERY_RANGE = [
  { label: "全文", value: 1 },
  { label: "标题", value: 2 },
];
